export default [
  {
    component: () => import('@/modules/chat/views/OpenChat.vue'),
    name: 'open-chat-thread',
    path: '/chat/:chatThreadId',
  },
]
